import { render, staticRenderFns } from "./photos.vue?vue&type=template&id=2cb1e670&scoped=true"
import script from "./photos.vue?vue&type=script&lang=js"
export * from "./photos.vue?vue&type=script&lang=js"
import style0 from "./photos.vue?vue&type=style&index=0&id=2cb1e670&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb1e670",
  null
  
)

export default component.exports